/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  RejectLedgerWithdrawRequestOptions,
  RejectLedgerWithdrawRequestResponses,
} from '../types/RejectLedgerWithdrawRequest'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Reject a pending withdrawal request, providing a reason for the rejection. Note that this does not interact with any external systems; it simply updates the status of the withdrawal request in the ledger. Actual transfer of assets must be handled separately.
 * @summary Reject a pending withdrawal request
 * {@link /v1/ledger/withdraw/requests/:withdrawal_id/reject}
 */
export function rejectLedgerWithdrawRequest<ThrowOnError extends boolean = true>(
  options: Options<RejectLedgerWithdrawRequestOptions, ThrowOnError>,
): Unwrappable<RequestResult<RejectLedgerWithdrawRequestResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/ledger/withdraw/requests/{withdrawal_id}/reject',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<RejectLedgerWithdrawRequestResponses, ThrowOnError>>,
  )
}
